/**
 *
 * App.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 */

import React from "react";
import { Helmet } from "react-helmet";
import { Switch, Route } from "react-router-dom";

import "pickups-ui-library/styles/global.scss";
import Auth from "containers/auth";
import GlobalSettings from "containers/global-settings";
import ReceiptRedirect from "containers/receipt-redirect";
import { Toast } from "pickups-ui-library";
import { REACT_APP_ORG_NAME } from "config";
import GoogleTagManagerNoscript from "../../utils/tracking/google-tag-manager-noscript";

const orgName = REACT_APP_ORG_NAME || "Donation Pickups";

export default function App() {
  return (
    <div>
      <Helmet titleTemplate={`${orgName} - %s`} defaultTitle={orgName} />
      <GoogleTagManagerNoscript />
      <Toast />
      <GlobalSettings>
        <>
          <Switch>
            <Route path="/r/:token" component={ReceiptRedirect} />
            <Route path="/" component={Auth} />
            <Route path="/donation-pickup" component={Auth} />
          </Switch>
        </>
      </GlobalSettings>
    </div>
  );
}
